const cellFooterValue = (entHeader, data) => {
  switch (entHeader.footerDataType) {
    case "count":
      return `Total Registros: ${data ? data.length : ""}`;
    case "sum":
      let valor = data.reduce(
        (accumulator, current) => accumulator + current[entHeader.header],
        0
      );
      return `Total: ${entHeader.type === "currency" ? "$ " + valor : valor}`;
    default:
      return entHeader.footerData;
  }
};

export default cellFooterValue;
